import { render, staticRenderFns } from "./Error405.vue?vue&type=template&id=330c4b63&scoped=true&"
import script from "./Error405.vue?vue&type=script&lang=js&"
export * from "./Error405.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330c4b63",
  null
  
)

export default component.exports